"use strict";
// @df/api - Unified authentication service for both apps
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthService = exports.authService = void 0;
const client_1 = require("./client");
const apiBase_1 = require("./config/apiBase");
class AuthService {
    // Login user
    async login(credentials) {
        const loginField = (0, apiBase_1.resolveJwtLoginField)();
        const payload = {
            [loginField]: credentials.username,
            password: credentials.password,
        };
        const response = await client_1.authClient.request('/auth/jwt/create/', {
            method: 'POST',
            body: JSON.stringify(payload),
        }, 0, true);
        return response;
    }
    // Refresh token
    async refreshToken(refreshToken) {
        const response = await client_1.apiAuthClient.request('/auth/jwt/refresh/', {
            method: 'POST',
            body: JSON.stringify({ refresh: refreshToken }),
        }, 0, true);
        return response;
    }
    // Verify token
    async verifyJwtToken(token) {
        const response = await client_1.authClient.request('/auth/jwt/verify/', {
            method: 'POST',
            body: JSON.stringify({ token }),
        }, 0, true);
        return response;
    }
    // Get current user
    async getMe() {
        const response = await client_1.apiClient.request('/me/', {
            method: 'GET',
        });
        return response;
    }
    // Get current user (backward-compatible alias)
    async getCurrentUser() {
        return this.getMe();
    }
}
exports.AuthService = AuthService;
// Export singleton instance
exports.authService = new AuthService();
